<template>
  <span class="form-group-label counter-label">{{ label }}</span>
</template>

<script>
export default {
  name: 'MFormGroupCounterLabel',
  props: {
    label: {
      type: [String, Number],
      default: 0,
    },
  },
};
</script>
